import {
  Dialog,
  ListItem,
  List,
  Toolbar,
  Slide,
  Grid,
  DialogTitle,
  Checkbox,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ButtonSubmit } from "../../../../../Components";
import { TextField2 } from "../../../../../Components/Field";
import { TransitionProps } from "@material-ui/core/transitions";
import { useIntl } from "react-intl";
import { useStyles } from "./DocumentGroup.style";
import DocumentGroupServices from "../../../../../Redux/Actions/DocumentGroup/DocumentGroupAction";
import { useDispatch, useSelector } from "react-redux";
import DropDownItem from "../DropDownItem";
import { AuthHeaders } from "../../../../../Redux/Reducers/Component";
import { interceptFetch } from "../../../../../Redux/InterceptFetch";
import { getAppConfiguration } from "../../../../../Config";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
type inputProps = {
  name: string;
  description: string;
};
interface createGrpupProps {
  editHandleClose: () => void;
  editOpen: boolean;
  addUserClose?: () => void;
  addopen?: any;
  group?: any;
  editRowData?: any;
  forceReload?: () => void;
  setReload?: () => void;
  data: any;
}
export const EditDocument = ({
  editOpen,
  editHandleClose,
  editRowData,
  data,
}: createGrpupProps) => {
  const { apiToken, currentUser } = useSelector((state: any) => ({
    apiToken: state?.UserReducer?.apiToken,
    currentUser: state?.UserReducer?.currentUser,
  }));
  const { formatMessage } = useIntl();
  const classes = useStyles();
  let [input, setInput] = useState<inputProps>({ name: "", description: "" });
  let [selectValue, setSelectValue] = useState<any>(null);
  let [checked, setChecked] = React.useState(false);
  const dispatch: any = useDispatch();
  const handleChange = (event: any) => {
    setChecked(event.target.checked);
  };
  useEffect(() => {
    setInput({
      name: editRowData?.name,
      description: editRowData?.description,
    });
    getDocumentByID();
    setChecked(editRowData?.restrictUploads);
  }, [editRowData]);
  const getDocumentByID = async () => {
    const mlsApiLocal = getAppConfiguration().mlsApiUrl;
    if (editRowData?.parentId) {
      const headers = AuthHeaders(apiToken);
      const options = { method: "GET", headers: headers };
      await interceptFetch(
        `${mlsApiLocal}document-groups/${editRowData?.parentId}`,
        options
      )
        .then((res: any) => setSelectValue(res))
        .catch((err) => console.log(err, "err"));
    }
  };
  const editDocumentGroup = () => {
    const userData = {
      name: input?.name,
      description: input?.description,
      customerId: editRowData?.customerId,
      parentId: selectValue?.id,
      restrictUploads: checked,
    };
    dispatch(
      DocumentGroupServices?.updateDocumentGroup(
        userData,
        editRowData?.id,
        apiToken
      )
    );
    setTimeout(() => {
      editHandleClose();
      dispatch(
        DocumentGroupServices?.allDocumentGroups(
          currentUser?.customerId,
          apiToken
        )
      );
    }, 2000);
  };
  return (
    <div>
      <Dialog
        open={editOpen}
        onClose={editHandleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title">
          {formatMessage({
            id: "group.document Group.structure",
            defaultMessage: "Document group structure",
          })}
        </DialogTitle>
        <List>
          <ListItem>
            <Grid style={{ marginLeft: 7 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField2
                    value={input?.name}
                    onChange={(str: string) =>
                      setInput({ ...input, name: str })
                    }
                    placeholder={formatMessage({
                      id: "group.user.groupName",
                      defaultMessage: "Group Name",
                    })}
                    Textlabel={"group.user.groupName"}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField2
                    value={input?.description}
                    onChange={(str: string) =>
                      setInput({ ...input, description: str })
                    }
                    placeholder={formatMessage({
                      id: "group.user.description",
                      defaultMessage: "Group Description",
                    })}
                    Textlabel={"group.user.description"}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                alignItems="center"
                className={classes.marginTop10}
              >
                {data?.length ? (
                  <Grid
                    item
                    xs={6}
                    style={{ paddingRight: "10px" }}
                    className="dropdownItemField"
                  >
                    <DropDownItem
                      data={data}
                      restrict={checked}
                      handleChange={(val) => setSelectValue(val)}
                      selectValue={selectValue}
                    />
                  </Grid>
                ) : (
                  ""
                )}
                <Grid item xs={6} className={classes.g_name}>
                  &nbsp;{" "}
                  {formatMessage({
                    id: "group.user.restrict",
                    defaultMessage: "Restrict document upload",
                  })}
                  <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "primary checkbox" }}
                    className="ml-2"
                  />
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
        </List>
        <Toolbar>
          <ButtonSubmit
            text={"model.title.cancel"}
            onClick={editHandleClose}
            className={classes.padding5}
          />
          <Grid container justifyContent={"flex-end"}>
            <ButtonSubmit
              text={"component.mtable.save"}
              onClick={editDocumentGroup}
            />
          </Grid>
        </Toolbar>
      </Dialog>
    </div>
  );
};
